<template>
  <div v-if="showActivator" class="ml-2" @click="activateWizard">
    <InfoIcon :size="20" :text="$t('views.common.wizardAlertActivator.activate')" :maxWidth="500" />
  </div>
</template>

<script>
import { get } from 'lodash'
import { mapState, mapActions } from 'vuex'
import { updateUser } from '@/lib/api.js'
import InfoIcon from '@/views/components/common/InfoIcon'

export default {
  components: {
    InfoIcon,
  },
  props: {
    section: {
      type: String,
      required: true,
    },
  },
  computed: {
    ...mapState(['user']),
    showActivator() {
      return !!get(this.user, `wizards.${this.section}`, null)
    },
  },
  methods: {
    ...mapActions({
      updateUsersInfo: 'UPDATE_USERS_INFO',
    }),
    async activateWizard() {
      const wizards = get(this.user, 'wizards', {})
      wizards[this.section] = false
      await updateUser({
        uid: this.user.uid,
        data: {
          wizards,
        },
      })
      await this.updateUsersInfo()
    },
  },
}
</script>

<style lang="scss"></style>
